module.exports = __webpack_public_path__ + "static/homeBackground-5e0786161cab5803e3d4c6dc288c9440.jpg";